import React, { useEffect, useState } from "react";
import store from "../../redux/store";
import {
  Card,
  Flex,
  Heading,
  HStack,
  Input,
  InputGroup,
  InputRightElement,
  Spacer,
  Td,
  Text,
  Tr,
} from "@chakra-ui/react";
import { FiSearch, FiTrash } from "react-icons/fi";
import TableView from "../../components/TableView";
import { useSelector } from "react-redux";
import CustomButton from "../../components/ButtonComp";
import CustomToolTip from "../../components/CustomTooltip";
import { useNavigate } from "react-router-dom";
import ConfirmDialog from "../../components/ConfirmDialog";
import { toast } from "react-toastify";
import {
  get_all_inventory_list,
  get_inventory_list,
} from "../../redux/inventorySlice";
import CustomSingleInput from "../../components/CustomSingleInput";
import { baseUrl } from "../../utils/utils";
import Loader from "../../components/Loader";

const LedgerReports = () => {
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [rows, setRows] = useState(5);
  const [page, setpage] = useState(1);
  const [initialValue, setInitialValue] = useState(1);
  const [deleteId, setDeleteId] = useState(null);
  const [total_count, setTotal_count] = useState(0);
  const [reports_list, setReports_list] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openingEmptys, setOpeningEmptys] = useState("");
  const [openingFulls, setOpeningFulls] = useState("");
  const { all_inventory_list } = useSelector((state) => state.inventory);

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [data, setData] = useState({});
  const product_list = all_inventory_list?.map((v) => ({
    label: `${v?.product_name} - ${v?.type}`,
    value: v?.uuid,
  }));

  console.log(selectedProduct,'selected')
  const handleDelete = async () => {
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("action", "delete");
      formData.append("id", deleteId);

      const response = await fetch(baseUrl + `inventory.php`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch product: ${response.statusText}`);
      }

      const result = await response.json();
      if (result?.success) {
        store.dispatch(get_inventory_list({ page: page, rows: rows }));
        toast.success(result?.message);
        setDeleteId(null);
        setDeleteDialog(false);
      } else {
        toast.error(result?.message);
      }
    } catch (error) {
      toast.error("Failed to load product data", {
        position: "top-right",
        autoClose: 5000,
      });
      navigate("/products");
    } finally {
      setIsLoading(false);
    }
  };

  const get_report_list = async () => {
    try {
      setLoading(true);
      const body = new FormData();

      body.append("action", "fetchledgerreport");
      body.append("page", page);
      body.append("limit", rows);
      body.append("fd", startDate);
      body.append("td", endDate);
      body.append("prod_code", selectedProduct);

      const response = await fetch(`${baseUrl}reports/ledger_report.php`, {
        method: "POST",
        body,
      });

      const res = await response.json();
      if (res?.success) {
        setReports_list(res?.list);
        setTotal_count(res.totalcount);
        setOpeningFulls(res.openingFulls);
        setOpeningEmptys(res.openingEmptys);
      } else {
        setReports_list([]);
        setTotal_count(0);
      }
    } catch (error) {
      console.log("Failed to fetch inventory list.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    store.dispatch(get_all_inventory_list());
  }, []);

  return (
    <>
      <Card
        bg="#fff"
        py={3}
        px={5}
        flexDirection={["column", "row"]}
        alignItems={["flex-start", "center"]}
        gap={3}
        flexWrap="wrap"
      >
        <Heading
          display="flex"
          w="full"
          alignItems="center"
          justifyContent="space-between"
          fontSize="xl"
        >
          Ledger Reports
        </Heading>
        <Spacer display={["none", "block"]} />
      </Card>

      <Card bg="#fff" py={3} px={5} gap={3}>
        <Flex
          direction={["column", "row"]}
          gap={3}
          flexWrap="wrap"
          w="full"
          justify="flex-start"
        >
          <CustomSingleInput
            width={["100%", "200px"]}
            label="Start Date"
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <CustomSingleInput
            width={["100%", "200px"]}
            label="End Date"
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
          <CustomSingleInput
            label="Product"
            width={["100%", "200px"]}
            placeholder="Select Product"
            select
            options={product_list}
            value={selectedProduct}
            onChange={(e) => setSelectedProduct(e.target.value)}
          />
          <CustomButton
            title="Search"
            w={["100%", "auto"]}
            onClick={() => {
              setData({
                sd: startDate,
                ed: endDate,
                pcode: selectedProduct,
              });
              get_report_list();
            }}
          />
        </Flex>

        {data?.sd && (
          <Text>
            From Date: <b>{data.sd}</b> To Date: <b>{data.ed}</b> Product
            Selected:{" "}
            <b>{product_list?.find((v) => v.value === data.pcode)?.label}</b>
          </Text>
        )}
      </Card>

      {loading ? (
        <Card justifyContent="center" alignItems="center" p={5}>
          <Loader />
        </Card>
      ) : reports_list?.length === 0 ? (
        <Card justifyContent="center" alignItems="center" h={20}>
          <Text>No Data</Text>
        </Card>
      ) : (
        <Card>
          <Flex
            direction={["column", "row"]}
            p={5}
            gap={3}
            justify="flex-start"
            align="flex-start"
          >
            <Text>Opening Emptys : {openingEmptys}</Text>
            <Text>Opening Fulls : {openingFulls}</Text>
          </Flex>
          <TableView
            headData={[
              "S.No.",
              "INV No",
              "INV DATE",
              "TRANSACTION TYPE",
              "Quantity",
              "Empties",
              "Current Fulls",
              "Current Empties",
            ]}
            body={reports_list?.map((el, i) => (
              <Tr key={i}>
                <Td textAlign="center">{i + initialValue}</Td>
                <Td textAlign="center">{el.inv_no}</Td>
                <Td textAlign="center">{el.trans_date}</Td>
                <Td textAlign="center">{el.TRANSACTION_TYPE}</Td>
                <Td textAlign="center">{el.fulls}</Td>
                <Td textAlign="center">{el.emptys}</Td>
                <Td textAlign="center">{el.CS_FULLS}</Td>
                <Td textAlign="center">{el.CS_EMPTYS}</Td>
              </Tr>
            ))}
            initialValue={initialValue}
            page={page}
            rows={rows}
            total_value={total_count}
            pagination
            onChange={(e) => {
              setInitialValue(1);
              setpage(1);
              store.dispatch(
                get_inventory_list({ page: 1, rows: e.target.value })
              );
              setRows(e.target.value);
            }}
            onPrevious={() => {
              initialValue !== 1 &&
                setInitialValue(Number(initialValue) - Number(rows));
              page !== 1 && setpage(page - 1);
              page !== 1 &&
                store.dispatch(
                  get_inventory_list({ page: page - 1, rows: rows })
                );
            }}
            onNext={() => {
              rows * page < total_count &&
                setInitialValue(Number(initialValue) + Number(rows));
              rows * page < total_count && setpage(page + 1);
              rows * page < total_count &&
                store.dispatch(
                  get_inventory_list({ page: page + 1, rows: rows })
                );
            }}
          />
          <ConfirmDialog
            isOpen={deleteDialog}
            onClose={() => setDeleteDialog(false)}
            onConfirm={handleDelete}
            type="delete"
            title="Delete Inventory"
            message="Are you sure you want to delete this Inventory? This action cannot be undone and will remove all associated data."
            confirmText="Delete"
            cancelText="Cancel"
            isLoading={isLoading}
          />
        </Card>
      )}
    </>
  );
};

export default LedgerReports;
